import { FamilialSearchResultItemModel, CaseRunClient, FSSystemModel, KinshipRelationship } from "@app/api2/api";
import { selectMany, toSci } from "@app/components/React/Common/Utils";
import { camelCase, uniqBy } from "lodash";
import React from "react";
import { Table, TableRow, TableHeaderCell, TableCell } from "@/components/bp/bp-ui";

interface IFamilialSearchHitDetailsProps {
    resultId: string;
    labId: number;
    caseId: number
    caseRunId: number;
    match: FamilialSearchResultItemModel;
}

export const FamilialSearchHitDetails: React.FunctionComponent<IFamilialSearchHitDetailsProps> = (props) => {
    const client = new CaseRunClient()
    const [result, setResult] = React.useState<FSSystemModel[]>([])

    React.useEffect(() => {
        let fetch = async () => {
            let results = await client.getFamilialSearchResultDetail(props.labId, props.caseId, props.caseRunId, props.resultId);
            setResult(results)
        }

        fetch();

    }, [props.resultId])

    const ds = React.useMemo(() => {
        return () => Promise.resolve({ items: result, totalRows: result?.length })
    }, [result, setResult])

    return <div className="widetable">
        <Table
            definition
            tableData={result}
            headerRows={[<TableRow>
                <TableHeaderCell></TableHeaderCell>
                <TableHeaderCell colSpan={2} style={{ whiteSpace: 'normal' }}>{props.match.uid1Name}</TableHeaderCell>
                <TableHeaderCell colSpan={2} style={{ whiteSpace: 'normal' }}>{props.match.uid2Name}</TableHeaderCell>
                {uniqBy(selectMany(result, r => r.relationships), x => x.relationship).map((person, idx) => {
                    return <TableHeaderCell key={"relh" + idx} colSpan={2}>{
                        window.translation.brutus.relationships[camelCase(KinshipRelationship[person.relationship])]
                    }</TableHeaderCell>
                })}
            </TableRow>,
            <TableRow>
                <TableHeaderCell></TableHeaderCell>
                <TableHeaderCell>AL1</TableHeaderCell>
                <TableHeaderCell>AL2</TableHeaderCell>
                <TableHeaderCell>AL1</TableHeaderCell>
                <TableHeaderCell>AL2</TableHeaderCell>
                {uniqBy(selectMany(result, r => r.relationships), x => x.relationship).map((person, idx) => {
                    return <React.Fragment key={"relh1" + idx}>
                        <TableHeaderCell>{window.translation.brutus.index}</TableHeaderCell>
                        <TableHeaderCell>{window.translation.common.formula}</TableHeaderCell>
                    </React.Fragment>
                })}
            </TableRow>]}
            renderBodyRow={(data: FSSystemModel, idx) => {
                return <TableRow key={data.system}>
                    <TableCell collapsing>{data.system}</TableCell>
                    {data.persons?.map(person => {
                        return <React.Fragment key={"per" + person.uid}>
                            <TableCell collapsing textAlign={'center'}>{person.alleles?.length > 0 ? person.alleles[0].value : ''}</TableCell>
                            <TableCell collapsing textAlign={'center'}>{person.alleles?.length > 1 ? person.alleles[1].value : person.alleles?.length > 0 ? person.alleles[0].value : ''}</TableCell>
                        </React.Fragment>
                    })}
                    {data.relationships?.map((person, idx) => {
                        return <React.Fragment key={"rel" + idx}>
                            <TableCell collapsing>{toSci(person.totalProbability)}</TableCell>
                            <TableCell collapsing>{person.totalFormula}</TableCell>
                            {/* <TableCell>{person.alleles?.length > 1 ? person.alleles[1].value : person.alleles?.length > 0 ? person.alleles[0].value : ''}</TableCell> */}
                        </React.Fragment>
                    })}
                </TableRow>
            }}>

        </Table>
    </div>;
};




